// Premium screenshot presentation: soft shadow, glass reflection, consistent rounding.
export const PhoneShot = ({ src, alt, className = "", float = false }) => (
  <div className={`relative ${float ? "drift" : ""} ${className}`}>
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="w-full rounded-[2.2rem] border border-line/40 shadow-[0_30px_64px_rgba(36,35,32,0.16)]"
    />
    <div className="pointer-events-none absolute inset-0 rounded-[2.2rem] bg-gradient-to-tr from-transparent via-white/5 to-white/25" />
    <div className="pointer-events-none absolute inset-x-6 top-3 h-10 rounded-full bg-white/20 blur-md" />
  </div>
);
